// FileDataContext.tsx

import React, { createContext, useContext, ReactNode } from "react";

type FileData = {
  floodFiles: Blob[];
  landFile: Blob | null;
  buildingFile: Blob | null;
  pngFiles: Blob[];
};

type FileDataContextType = {
  fileData: FileData;
  setFileData: React.Dispatch<React.SetStateAction<FileData>>;
};

const defaultFileData: FileData = {
  floodFiles: [],
  landFile: null,
  buildingFile: null,
  pngFiles: [],
};

const FileDataContext = createContext<FileDataContextType | undefined>(undefined);

type Props = {
  children: ReactNode;
};

export const FileDataProvider: React.FC<Props> = ({ children }) => {
  const [fileData, setFileData] = React.useState<FileData>(defaultFileData);

  return (
    <FileDataContext.Provider value={{ fileData, setFileData }}>
      {children}
    </FileDataContext.Provider>
  );
};

export const useFileData = () => {
  const context = useContext(FileDataContext);
  if (!context) {
    throw new Error("useFileData must be used within a FileDataProvider");
  }
  return context;
};
